import { SVGProps } from "react"
const NewPhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2299 14.5878C11.7822 16.0354 8.07486 14.6752 4.94927 11.5496C1.82368 8.424 0.463432 4.71666 1.91107 3.26901L2.86423 2.31585C3.52225 1.65783 4.60651 1.67523 5.28598 2.3547L6.76235 3.83107C7.44182 4.51054 7.45922 5.5948 6.8012 6.25282L6.59647 6.45755C6.24119 6.81282 6.20644 7.38595 6.53655 7.78599C6.85497 8.17186 7.19825 8.5562 7.57046 8.9284C7.94266 9.30061 8.327 9.64389 8.71287 9.96231C9.11291 10.2924 9.68604 10.2577 10.0413 9.90239L10.246 9.69766C10.9041 9.03964 11.9883 9.05704 12.6678 9.73651L14.1442 11.2129C14.8236 11.8924 14.841 12.9766 14.183 13.6346L13.2299 14.5878Z"
      stroke="#2768A3"
    />
  </svg>
)
export default NewPhoneIcon
